export const replaceComma = (str: string) => str.replace(/,/g, "，");